import React, { useMemo } from 'react';
import { useLanguage } from '../../../utils/useLanguage';
import { VideoChromeGif, VideoEdgeGif, VideoFirefoxGif, VideoSafariGif, CloseIcon } from '../../../../../assets/images';
import { hidePopup } from '../../../utils/popupService';
import './CameraPermissionPopup.scss';

const CameraPermissionPopup = () => {
    const { t } = useLanguage();

    const getBrowserGif = useMemo(() => {
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf('edg/') > -1) return VideoEdgeGif;
        if (userAgent.indexOf('firefox') > -1) return VideoFirefoxGif;
        if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1) return VideoSafariGif;
        // Default to Chrome for all other browsers including Chrome itself
        return VideoChromeGif;
    }, []);

    const handleTryAgain = () => {
        window.location.reload();
    };

    const handleClose = () => {
        hidePopup('cameraPermissionPopup');
    };

    return (
        <div className="camera-permission-popup ct-flex ct-fcol">
            <button type="button" className="close-btn ct-absolute ct-cursor" onClick={handleClose}>
                <CloseIcon />
            </button>

            <div className="camera-permission-header ct-flex ct-fcol ct-wFull">
                <h2 className="camera-permission-title">{t('common.VIDEO_PERMISSION_TITLE')}</h2>
                <p className="camera-permission-subtitle">{t('common.VIDEO_PERMISSION_SUBTITLE')}</p>
            </div>

            <div className="camera-permission-media ct-flexCenter ct-wFull">
                <img src={getBrowserGif} alt="Camera Permission Guide" className="camera-permission-gif" />
            </div>

            <div className="camera-permission-steps ct-flex ct-fcol ct-wFull">
                <ul className="camera-permission-list ct-flex ct-fcol ct-gap30">
                    <li className="camera-permission-item ct-flex ct-aiCenter ct-gap12">
                        <span className="dot"></span>
                        <p>{t('common.VIDEO_PERMISSION_STEP1')}</p>
                    </li>
                    <li className="camera-permission-item ct-flex ct-aiCenter ct-gap12">
                        <span className="dot"></span>
                        <p>{t('common.VIDEO_PERMISSION_STEP2')}</p>
                    </li>
                    <li className="camera-permission-item ct-flex ct-aiCenter ct-gap12">
                        <span className="dot"></span>
                        <p>{t('common.VIDEO_PERMISSION_STEP3')}</p>
                    </li>
                </ul>
            </div>

            <div className="camera-permission-actions ct-flexCenter ct-wFull">
                <button className="camera-try-again-btn ct-flexCenter ct-cursor" onClick={handleTryAgain}>
                    {t('common.TRY_AGAIN')}
                </button>
            </div>
        </div>
    );
};

export default CameraPermissionPopup;
